export default "__VITE_ASSET__2CtLvk2I__"